export default class BaseModel {
	idAttribute = 'id';
	id;
	url;
	key;
	object_type;
	htmlView;
	imgURL;
	data;

	/** Handles the JS fetch call to the API */
	async fetch() {
		const response = await fetch(this.url);
		const data = await response.json();
		this.data = data;
		return this;
	}
}
